<div class="wrapper">
  <div class="flex column grow1">
    <div class="flex grow1">
      <div class="flex column hcenter grow1">
        <div class="flex subtitle" *ngIf="subtitle">{{ subtitle }}</div>
        <div class="flex title" *ngIf="title">{{ title }}</div>
      </div>
      <div
        class="flex vcenter"
        style="padding-top: 31px; padding-bottom: 20px; gap: 16px"
      >
        <payee-language-selector></payee-language-selector>

        <button
          payee-button
          id="profile-button"
          color="white"
          [isBorderButton]="true"
          routerLink="/user/user-profile"
        >
          {{ userInitials }}
        </button>

        <button
          payee-icon-button
          id="logout-button"
          color="white"
          [isBorderButton]="true"
          (click)="logout()"
        >
          <payee-icon name="logout-red"></payee-icon>
        </button>
      </div>
    </div>
  </div>
</div>
